import Color from "color";

/**
 *
 * @param {Color|*} color
 * @returns {Color}
 */
function getColor(color) {
  return color instanceof Color ? color : Color(color);
}

/**
 *
 * @param {Color|*} color
 * @param {number} ratio
 *
 * @returns {Color}
 */
export function lightenBy(color, ratio) {
  const col = getColor(color);
  const lightness = col.lightness();
  return color.lightness(lightness + (100 - lightness) * ratio);
}

/**
 *
 * @param {Color|*} color
 * @param {number} ratio
 *
 * @returns {Color}
 */
export function darkenBy(color, ratio) {
  const col = getColor(color);
  const lightness = col.lightness();
  return color.lightness(lightness - lightness * ratio);
}
